import { fork } from 'redux-saga/effects';
import adminRootSaga from '../modules/admin-panel/store/rootSaga';
import surveySaga from '../modules/survey/survey.saga';

export default function* root() {
	console.warn('> Root saga started');
	yield fork(adminRootSaga);
	yield fork(surveySaga);
}
